import MascotasCoveragesTable from "./mascotas-coverages-table";

export default MascotasCoveragesTable;
